import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-4]",
  templateUrl: "./wall-type-4.component.html",
  styleUrls: ["./wall-type-4.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType4Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Tracker
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M0 91 L114 158 L114 ${baseHeight + 18} L0 ${baseHeight - 48} Z`,
        right: `M114 158 L188 114 L188 ${baseHeight - 26} L114 ${baseHeight + 18} Z`
    };

    return wallData[wallSide];
  }
}
